import { useGetInfo } from "antopolis-react-utils/hooks";
import React, { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../../../Contexts/GlobalContexts/AuthContext";
import { useAxiosInstance } from "../../../../../../Utilities/Hooks/useAxiosInstance";
import BackButton from "../../../../../Partials/Elements/BackButton/BackButton";
import { Modal } from "../../../../../Partials/Elements/Modal/Modal";
import {
  ViewButton
} from "../../../../../Partials/Layout/CRUD/CRUDButtons/CRUDButtons";
import { CRUDTable } from "../../../../../Partials/Layout/CRUD/CRUDTable/CRUDTable";
import { CRUDTableHeader } from "../../../../../Partials/Layout/CRUD/CRUDTableHeader/CRUDTableHeader";
import { CRUDth } from "../../../../../Partials/Layout/CRUD/CRUDth/CRUDth";
import { ShortTextCell } from "../../../../../Partials/Layout/CRUD/ShortTextCell/ShortTextCell";
import ViewAddress from "./ViewAddress";

function AddressesFromCustomer({ api }) {
  const navigate = useNavigate();
  const { customerID } = useParams();
  const [showViewSection, setShowViewSection] = useState(false);
  const [toggleFetch, setToggleFetch] = useState(false);

  const [targetID, setTargetID] = useState(null);
  const { employee } = useContext(AuthContext);
  const axiosInstance = useAxiosInstance();
  const { info: addresses  } = useGetInfo({
    axiosInstance: axiosInstance,
    api: api + "addresses/" + customerID,
    toggleFetch,
  });
  return (
    <div className="screen_wrapper">
      <div className="screen_header">
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <BackButton />
          <h1 className="screen_heading">{`Addresses  (${addresses?.length} in total)`}</h1>
        </div>
      </div>
      <CRUDTable>
        <CRUDTableHeader>
          <CRUDth th="Address Name" />
          <CRUDth th="Address Type" />
          <CRUDth th="Actions" />
        </CRUDTableHeader>
        <tbody>
          {addresses&&
            addresses?.map((e) => (
              <tr key={e._id}>
                <ShortTextCell text={e.name} />
                <ShortTextCell text={e.type} />
                <td>
                  <div className="action_buttons">
                    <ViewButton
                      setShowViewSection={setShowViewSection}
                      targetID={e._id}
                      setTargetID={setTargetID}
                    />
                   
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </CRUDTable>
      {showViewSection && (
        <Modal
          extraClass={"small"}
          modalHeading={`View Address`}
          setShowModalContent={setShowViewSection}
        >
          <ViewAddress targetID={targetID} api={api} toggleFetch={toggleFetch} />
        </Modal>
      )}
    </div>
  );
}

export default AddressesFromCustomer;
